import { render, staticRenderFns } from "./CompanyProfileForm.vue?vue&type=template&id=0297d7a4&scoped=true"
import script from "./CompanyProfileForm.vue?vue&type=script&lang=js"
export * from "./CompanyProfileForm.vue?vue&type=script&lang=js"
import style0 from "./CompanyProfileForm.vue?vue&type=style&index=0&id=0297d7a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0297d7a4",
  null
  
)

export default component.exports